module.exports = __webpack_public_path__ + "img/sample.4f4a78a3.jpg";